export default {
  roomInfo: null, // Oda detayları, token vb.
  isHost: false, // Kullanıcı host mu?
  isMuted: false, // Host'un mikrofonu kapalı mı? (Host ise geçerli)
  pendingSpeakerRequests: [], // { userId: '...', userName: '...', userAvatar: '...' } gibi objeler
  speakers: [], // Aktif konuşmacılar listesi { id: '...', name: '...', avatar: '...', isMuted: false, isSpeaking: false, uuid: '...', ... }
  audience: [], // Dinleyiciler listesi { userId: '...', userName: '...', userAvatar: '...' }
  mainHost: null, // Ana sunucu bilgisi { id: '...', name: '...', avatar: '...', isMuted: false, isSpeaking: false, uuid: '...', ... }
  streamTitle: '', // Oda başlığı
  goals: [], // Oda hedefleri [{ goalType: 1, goalTarget: 1000, currentValue: 500, ... }, ...]
  audienceCount: 0, // Dinleyici sayısı (heartbeat ile güncellenir)
  giftSenders: [], // Hediye gönderenlerin listesi (API'dan gelen formatta)
  availableGifts: [], // Add availableGifts state
}
